import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { url } from "./env";

const ProtectedRoute = ({ element, allowedRoles }) => {
    const [isVerified, setIsVerified] = useState(null);

    const storedData = localStorage.getItem("attendance_teacher") || sessionStorage.getItem("attendance_teacher");
    let data = null;

    try {
        data = storedData ? JSON.parse(storedData) : null;
    } catch (error) {
        console.error("Error parsing stored data:", error);
    }

    const token = data?.token;
    const role = data?.role;

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setIsVerified(false);
                return;
            }

            const api = role === "teacher" ? `${url}teachers/verify-token` : `${url}Authentication/verify-token`;

            try {
                const response = await fetch(api, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                });

                if (response.ok && allowedRoles.includes(role)) {
                    setIsVerified(true);
                } else {
                    setIsVerified(false);
                }
            } catch (error) {
                console.error("Token verification failed:", error);
                setIsVerified(false);
            }
        };

        verifyToken();
    }, [token, role, allowedRoles]);

    if (isVerified === null) {
        return <div>Loading...</div>;
    }

    return isVerified ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;
